export default __webpack_public_path__ + "static/media/m2.c8037946.jpg";